import { firebase_Auth } from "../config/firebaseConfig";

import React, { createContext, useContext, useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";

const authContext = createContext();

export function useAuth() {
  return useContext(authContext);
}

const FAuth = ({ children }) => {
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    const unsubscribe = firebase_Auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });

    return unsubscribe;
  }, [currentUser]);

  const FLogin = async (email, password) => {
    try {
      return await firebase_Auth.signInWithEmailAndPassword(email, password);
    } catch (error) {
      return alert(error.message);
    }
  };

  const LogOut = async () => {
    try {
      return await firebase_Auth.signOut().then(() => {
        localStorage.removeItem("User");
      });
    } catch (error) {
      return alert(error.message);
    }
  };

  const value = {
    currentUser,
    FLogin,
    LogOut,
  };
  return <authContext.Provider value={value}>{children}</authContext.Provider>;
};

export default FAuth;
